import { AnimatePresence, motion } from 'motion/react'
import type { ReactNode } from 'react'

type ActivationCardShellProps = {
  cardStateKey: string
  prefersReducedMotion: boolean
  stateTransition: {
    duration: number
    ease: readonly [number, number, number, number]
  }
  children: ReactNode
}

export const ActivationCardShell = ({
  cardStateKey,
  prefersReducedMotion,
  stateTransition,
  children,
}: ActivationCardShellProps) => (
  <div className="ca-card-shell ca-theme-transition relative overflow-hidden rounded-2xl border-[color-mix(in_srgb,var(--color-border-strong)_68%,var(--color-border-default))] bg-[linear-gradient(160deg,color-mix(in_srgb,var(--color-bg-card)_95%,var(--color-bg-page-secondary))_0%,color-mix(in_srgb,var(--color-bg-card)_90%,var(--color-bg-page-secondary))_100%)] px-6 py-6 shadow-[0_44px_86px_-50px_color-mix(in_srgb,var(--color-text-primary)_48%,transparent)] sm:px-8 sm:py-8">
    <div
      aria-hidden
      className="pointer-events-none absolute inset-x-8 top-0 h-14 rounded-b-2xl bg-[linear-gradient(180deg,color-mix(in_srgb,var(--color-bg-card)_92%,white)_0%,transparent_100%)] opacity-70"
    />
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={cardStateKey}
        initial={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: 8 }}
        transition={stateTransition}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  </div>
)
